/**
 * contentValidators/shared.ts — Shared constants and types for content stage validators.
 *
 * AUDIT v1.4 / Sprint 4 (C21, V1b): the literal `3` is no longer hardcoded here;
 * it is sourced from the central stage-definitions file so renumbering happens
 * in exactly one place.
 */

import type { PipelineStage } from '../../issueContract';
import { STAGES } from '../../stageDefinitions';
export const STAGE: PipelineStage = STAGES.CONTENT;